import {
  ReportStage,
  ReportStatus,
} from 'donor/portal/pages/FeedbackDashboard/api';
import { Answer } from './Components/Review/utils';
import {
  IMPACT_SUMMARY_QUESTION_ID,
  INDICATOR_DETAILS_QUESTION_ID,
} from '../NPOFeedback/utils';
import { parseImpactSummaryAnswer } from '../NPOFeedback/FeedbackDetails/ImpactSummaryDetails';
import { parseImpactDetailsAnswer } from 'donor/portal/pages/FeedbackDashboard/Feedback/FeedbackImpactDetails';
import { validateModel } from '../NPOFeedback/MakeEdits/components/ImpactTable/modelErrors';
import { IndicatorByService } from './Components/ImpactIndicator/utils';
import { SectionIndicators } from './Components/IndicatorDetails/utils';

export const getImpactSummaryAnswer = (answers: Answer[]) => {
  const impactSummary = answers.find(
    a => a.question.dbId === IMPACT_SUMMARY_QUESTION_ID,
  )?.text;
  return parseImpactSummaryAnswer(impactSummary);
};

export const getImpactDetailsAnswer = (answers: Answer[]) => {
  const impactDetails = answers.find(
    a => a.question.dbId === INDICATOR_DETAILS_QUESTION_ID,
  )?.text;
  return parseImpactDetailsAnswer(impactDetails);
};

export const checkSectionAnswers = (
  answers: Answer[],
  impactSummary: IndicatorByService,
  impactDetails: SectionIndicators,
  isReportPassed: boolean,
  reportStatus: ReportStatus,
  reportStage: ReportStage,
  year: number,
): boolean => {
  // const summary = getImpactSummaryAnswer(answers);
  // const details = getImpactDetailsAnswer(answers);
  if (!impactSummary || !impactDetails) return false;
  const validation = validateModel(
    impactSummary,
    impactDetails,
    isReportPassed,
  );
  return validation.errors.length === 0;
};
